define('toasties',[

    "toastr"

], function(

    Toastr

){

    window.toastr = Toastr;

    /**
     * Toasties
     *
     * wrapper class for Toastr     *
     * offers functions to show prepared and styled toasties with messages to the user
     */

    var LOG_LABEL = "TOASTIES";


    var Utils = {simpleMerge: function(){
        var target = arguments[0];
        for(var i = 1; i < arguments.length; i++){
            for(var i2 in arguments[i]){
                target[i2] = arguments[i][i2];
            }
        }
        return target;
    }};

    var _v = {
            isUnloading: false,
            options: {
                btnDefault: {
                    label: "Close",
                    callback: null,
                    class: "btn-primary"
                },
                bigTopRight: {
                    closeButton: true,
                    tapToDismiss: false,
                    preventDuplicates: true,
                    timeOut: 0,
                    progressBar: false,
                    extendedTimeOut: 0,
                    containerId: "toastr-container-top-right",
                    positionClass: "toast-top-right"
                },
                tinyTopCenter: {
                    closeButton: false,
                    tapToDismiss: true,
                    debug: false,
                    progressBar: true,
                    preventDuplicates: false,
                    positionClass: "toast-top-center toast-tiny",
                    wide: false,
                    onclick: null,
                    showDuration: 400,
                    hideDuration: 1000,
                    timeOut: 3000,
                    containerId: "toastr-container-top-center",
                    extendedTimeOut: 1000
                }
            }
        },
        _fn = {
            init: function(){
                window.addEventListener("beforeunload", function(){
                    _v.isUnloading = true;
                    Toastr.clear();
                });
            },
            showToast: function(type, message, title, optionType, btnOptions, moreOptions){
                if(_v.isUnloading) return;
                var btn;

                // -- check and set default values


                if(!Toastr[type]){
                    console.error(LOG_LABEL, "unsupported toasty type", type, arguments);
                    return;
                }

                if(!_v.options[optionType]){
                    console.error(LOG_LABEL, "unsupported toasty options", optionType, arguments);
                    return;
                }
                var options = _v.options[optionType];

                if(moreOptions){
                    options = Utils.simpleMerge(options, moreOptions);
                }


                title = title || null;

                message = message || "";

                if(Array.isArray(message)){
                    message = message.join("\n");
                }

                message = message.replace("\n", "<br/>");


                // -- prepare button

                if(btnOptions){
                    var defaultBtnOptions = Utils.simpleMerge(_v.options.btnDefault, {class: 'btn-' + type});
                    btn = {};

                    for(var attr in defaultBtnOptions){
                        var val = defaultBtnOptions[attr];
                        btn[attr] = btnOptions[attr] || val;
                    }

                    btn.elm =    '<div style="padding-top:.5em;" class="text-right">' +
                                    '<button type="button" class="btn ' + btn.class + ' clear-toasty"><b>' + btn.label + '</b></button>' +
                                '</div>';

                    // with a button -> disable tapToDismiss
                    options.tapToDismiss = false;


                }

                if(options.wide){
                    options.positionClass += " toast-wide";
                }

                var isShown = true;
                options.onHidden = function(){isShown = false;};

                // -- set options and show toasty

                var toastMessage = message && message.length ? '<p>' + message + '</p>' : '',
                    toastBtn = btn ? btn.elm : "",
                    toast = Toastr[type](toastMessage + toastBtn, title, options);

                if(toast){
                    // -- set button callback
                    if (btn && toast.find('.clear-toasty').length) {
                        toast.delegate('.clear-toasty', 'click', function () {
                            if(typeof btn.callback === "function"){
                                btn.callback.apply(this);
                            }

                            Toastr.clear(toast, { force: true });
                        });
                    }

                    toast.clear = function(){
                        Toastr.clear(toast, {force: true});
                    };

                    toast.isShown = function(){
                        return isShown;
                    };
                }


                return toast;

            }

        },
        fn = {
            warn: function(title, message, buttonLabel, buttonFn, options){

                var btn = {
                    label: buttonLabel,
                    callback: buttonFn,
                    class: "btn-warning"
                };

                return _fn.showToast('warning', message, title, 'bigTopRight', btn, options);

            },
            warning: function(){
                // deprecated -- use "warn" instead // TODO: replace all "Toasties.warning" with "Toasties.warn"
                return fn.warn.apply(this, arguments);
            },
            error: function(title, message, buttonLabel, buttonFn, options){

                var btn = {
                    label: buttonLabel,
                    callback: buttonFn,
                    class: "btn-danger"
                };

                return _fn.showToast('error', message, title, 'bigTopRight', btn, options);

            },
            success: function(title, message, buttonLabel, buttonFn, options){

                var btn = {
                    label: buttonLabel,
                    callback: buttonFn,
                    class: "btn-success"
                };

                return _fn.showToast('info', message, title, 'bigTopRight', btn, options);

            },

            info: function(title, message, buttonLabel, buttonFn, options){

                var btn = {
                    label: buttonLabel,
                    callback: buttonFn,
                    class: "btn-info"
                };

                return _fn.showToast('info', message, title, 'bigTopRight', btn, options);

            },
            tiny: function(title, message, quick, options){

                var quickTimeout = 750,
                    moreOptions = Utils.simpleMerge({
                        progressBar: !quick, // = hide by default if quick
                        type: "info",
                        timeout: quick ? quickTimeout : null,
                        wide: false
                    }, options || {});

                return _fn.showToast(moreOptions.type, message, title, 'tinyTopCenter', null, moreOptions);

            },
            clear: function(toast){
                if(toast)
                    Toastr.clear(toast, { force: true });
                else
                    Toastr.clear();
            }

        };


    return fn;

});

